export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/asciiGenerator.worker.475e7fdd.worker.js");
}
